import { useCallback, useEffect, useState } from "react";
import { useRecoilState } from "recoil";

import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { PremiumWebinarHighlightsState } from "@/view_models/atoms";

export const usePremiumWebinarHighlights = () => {
  const [webinars, setWebinars] = useRecoilState(PremiumWebinarHighlightsState);
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const fetchHighlights = useCallback(async () => {
    setLoading(true);
    try {
      const api = PropallyApiFactory();
      const response = await api.v1WebinarsHighlightGet({ withCredentials: true });
      setWebinars(response.data.webinars ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setInitialized(true);
    }
  }, [setWebinars]);

  useEffect(() => {
    if (!initialized && webinars.length === 0) {
      fetchHighlights();
    }
  }, [fetchHighlights, initialized, webinars.length]);

  return {
    webinars,
    loading,
    refetch: fetchHighlights,
  };
};
